import "./MyAccount.style.scss";
import styles from "./MyAccount.module.scss";
import { userInfoAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import { Button, Modal } from "react-bootstrap";
import { maxLengthValidation } from "src/utils/validation";
import { useTranslation } from "react-i18next";
import useMyAccountModal from "src/hooks/Modal/MyAccount/useMyAccountModal";

interface IMyAccountUIProps {
  modal: any;
  handleChange: any;
  toggleModalEditName: any;
  toggleModalEditEmail: any;
  toggleModalEditPassword: any;
  toggleModalCancelMember: any;
  confirmEditName: any;
  confirmEditEmail: any;
  confirmEditPassword: any;
  confirmCancelMember: any;
  newUserName: any;
  newEmail: any;
  newEmailCheck: any;

  newUserNameNoti: any;
  newEmailNoti: any;
  newEmailCheckNoti: any;
  passwordCheck: string;
  passwordCheckNoti: any;
  newPasswordCheckNoti: any;
  confirmPasswordNoti: any;
  withDrawalMember: any;
  confirmWithDrawalMember: any;
  withdrawable: boolean;
}
// 다시 만들것!!!
const MyAccountUI = ({
  modal,
  handleChange,
  toggleModalEditName,
  toggleModalEditEmail,
  toggleModalEditPassword,
  toggleModalCancelMember,
  confirmEditName,
  confirmEditEmail,
  confirmCancelMember,
  newUserName,
  newEmail,
  newEmailCheck,

  newUserNameNoti,
  newEmailNoti,
  newEmailCheckNoti,
  passwordCheck,
  passwordCheckNoti,
  withDrawalMember,
  withdrawable,
}: IMyAccountUIProps) => {
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { t } = useTranslation();
  return (
    <div className="content myAccount">
      <h3 className="content__title">{t("navBar.myAccount.fieldname")}</h3>

      <div className="userInfoMore">
        <div className="flex">
          <div className="userInfoMore__profile">
            {userInfo.userName.substr(0, 2)}
          </div>
          <div className="userInfoMore__info">
            <span className="userInfoMore__name">{userInfo.userName}</span>
            <span className="userInfoMore__email">{userInfo.userId}</span>
          </div>
        </div>
      </div>

      <div className="mg mt-30">
        <div className="flex align-center">
          <b className="text text--lg text--black">
            {t("navBar.myAccount.basicInfo")}
          </b>
          {withdrawable && (
            <button
              type="button"
              className="btn btn-transparent text text--orange mg ml-auto"
              onClick={toggleModalCancelMember}
            >
              <i className="icon_trash inline-block vertical-middle" />
              <span className="inline-block vertical-middle mg ml-2 text text--13">
                {t("navBar.myAccount.withDrawal")}
              </span>
            </button>
          )}
        </div>

        <hr className="divider mg mt-10" />
        <div className="myAccount__item">
          <span className="myAccount__itemKey">
            {t("navBar.myAccount.name")}
          </span>
          <span className="myAccount__itemValue">
            {userInfo.userName}
            {/* <b
              className="text cursor-pointer mg ml-10"
              style={{ color: "#3182F6" }}
              onClick={toggleModalEditName}
            >
              {t("navBar.myAccount.edit")}
            </b> */}
          </span>
        </div>
        <div className="myAccount__item">
          <span className="myAccount__itemKey">
            {t("navBar.myAccount.email")}
          </span>
          <span className="myAccount__itemValue">
            {userInfo.userEmail}
            {/* <b
              className="text cursor-pointer mg ml-10"
              style={{ color: "#3182F6" }}
              onClick={toggleModalEditEmail}
            >
              {t("navBar.myAccount.edit")}
            </b> */}
          </span>
        </div>
        <div className="myAccount__item">
          <span className="myAccount__itemKey">
            {t("navBar.myAccount.companyName")}
          </span>
          <span className="myAccount__itemValue">
            {userInfo.companyName}
            {/* <b
          className="text text--green cursor-pointer mg ml-10"
          onClick={toggleModalEditCompanyName}
        >
          {t('navBar.myAccount.edit')}
        </b> */}
          </span>
        </div>
        <div className="myAccount__item">
          <span className="myAccount__itemKey">
            {t("navBar.myAccount.password")}
          </span>
          <span className="myAccount__itemValue">
            ************
            <b
              className="text cursor-pointer mg ml-10"
              style={{ color: "#3182F6" }}
              onClick={toggleModalEditPassword}
            >
              {t("navBar.myAccount.edit")}
            </b>
          </span>
        </div>
      </div>

      {/* {modal?.confirmEditName && (
        <Modal
          show={modal.confirmEditName}
          onHide={() => toggleModalEditName()}
          className="modal--sm"
          style={{ opacity: 1 }}
          centered
          dialogClassName={styles.modalDialogSm}
        >
          <Modal.Header closeButton>
            <h4 className={styles.modalHeaderTitle}>
              {t("navBar.myAccount.popUp.changeName.title")}
            </h4>
          </Modal.Header>
          <Modal.Body className={styles.modalBodySm}>
            <div className="flex justify-flex-end text text--13">
              <input
                id="newUserName"
                name="newUserName"
                value={newUserName}
                type="text"
                placeholder={t("navBar.myAccount.popUp.changeName.enterName")}
                className={
                  newUserNameNoti === "" && newUserName === ""
                    ? "form-control custom-form mg mb-20"
                    : `${
                        newUserNameNoti === ""
                          ? "form-control form-textbox-valid custom-form mg mb-20"
                          : "form-control form-textbox-invalid custom-form mg mb-20"
                      }`
                }
                onChange={handleChange}
              />
            </div>

            {newUserNameNoti !== "" ? (
              <div className="mg mt--10 mb-20">
                <span className="form-invalid">{newUserNameNoti}</span>
              </div>
            ) : (
              ""
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className={`btn btn-gray ${styles.secondaryActionButton}`}
              onClick={toggleModalEditName}
            >
              {t("common.cancelBtn")}
            </Button>
            <Button
              className={`${styles.primaryActionButton}`}
              onClick={confirmEditName}
            >
              {t("common.okBtn")}
            </Button>
          </Modal.Footer>
        </Modal>
      )} */}
      {modal?.confirmEditEmail && (
        <Modal
          show={modal.confirmEditEmail}
          onHide={() => toggleModalEditEmail()}
          className="modal--sm"
          style={{ opacity: 1 }}
          centered
          dialogClassName={styles.modalDialogSm}
        >
          <Modal.Header closeButton>
            <h4 className={styles.modalHeaderTitle}>
              {t("navBar.myAccount.popUp.changeEmail.title")}
            </h4>
          </Modal.Header>
          <Modal.Body className={styles.modalBodySm}>
            <div className="flex flex-wrap text text--13">
              <input
                id="newEmail"
                name="newEmail"
                value={newEmail}
                type="text"
                placeholder={t("navBar.myAccount.popUp.changeEmail.enterEmail")}
                autoComplete="off"
                className={
                  newEmailNoti === "" && newEmail === ""
                    ? "form-control custom-form mg mb-20"
                    : `${
                        newEmailNoti === ""
                          ? "form-control form-textbox-valid custom-form mg mb-20"
                          : "form-control form-textbox-invalid custom-form mg mb-20"
                      }`
                }
                onChange={handleChange}
              />

              {newEmailNoti !== "" ? (
                <div className="mg mt--10 mb-20">
                  <span className="form-invalid">{newEmailNoti}</span>
                </div>
              ) : (
                ""
              )}

              <input
                id="newEmailCheck"
                name="newEmailCheck"
                value={newEmailCheck}
                type="text"
                placeholder={t(
                  "navBar.myAccount.popUp.changeEmail.confirmEmailAddress"
                )}
                autoComplete="off"
                className={
                  newEmailCheckNoti === "" &&
                  newEmailCheck === "" &&
                  maxLengthValidation(newEmailCheck, 254)
                    ? "form-control custom-form mg mb-20"
                    : `${
                        newEmailCheckNoti === ""
                          ? "form-control form-textbox-valid custom-form mg mb-20"
                          : "form-control form-textbox-invalid custom-form mg mb-20"
                      }`
                }
                onChange={handleChange}
              />

              {newEmailCheckNoti !== "" ? (
                <div className="mg mt--10 mb-20">
                  <span className="form-invalid">{newEmailCheckNoti}</span>
                </div>
              ) : (
                ""
              )}

              <input
                id="passwordCheck"
                name="passwordCheck"
                value={passwordCheck}
                type="password"
                placeholder={t("navBar.myAccount.popUp.changeEmail.password")}
                autoComplete="off"
                className={
                  passwordCheckNoti === "" && passwordCheck === ""
                    ? "form-control custom-form mg mb-20"
                    : `${
                        passwordCheckNoti === ""
                          ? "form-control form-textbox-valid custom-form mg mb-20"
                          : "form-control form-textbox-invalid custom-form mg mb-20"
                      }`
                }
                onChange={handleChange}
              />

              {passwordCheckNoti !== "" ? (
                <div className="mg mt--10 mb-20">
                  <span className="form-invalid">{passwordCheckNoti}</span>
                </div>
              ) : (
                ""
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className={`btn btn-gray ${styles.secondaryActionButton}`}
              onClick={toggleModalEditEmail}
            >
              {t("common.cancelBtn")}
            </Button>
            <Button
              className={`${styles.primaryActionButton}`}
              onClick={confirmEditEmail}
            >
              {t("common.okBtn")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {modal?.confirmWithDrawalMember && (
        <Modal
          show={modal.confirmWithDrawalMember}
          onHide={() => toggleModalCancelMember()}
          className="modal--sm confirm__cancel"
          style={{ opacity: 1 }}
          centered
          dialogClassName={styles.modalDialogSm}
        >
          <Modal.Header closeButton>
            <h4 className={styles.modalHeaderTitle}>
              {t("navBar.myAccount.popUp.withDrawal.title")}
            </h4>
          </Modal.Header>
          <Modal.Body className={styles.modalBodySm}>
            <p className="text text--14">
              {t("navBar.myAccount.popUp.withDrawal.leaveMember")}
            </p>
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <Button
              className={`btn btn-gray btn-40 width min-w-73 ${styles.secondaryActionButton}`}
              onClick={toggleModalCancelMember}
            >
              {t("common.cancelBtn")}
            </Button>
            <Button
              className={`btn btn-40 width min-w-73 ${styles.primaryActionButton}`}
              onClick={withDrawalMember}
            >
              {t("common.okBtn")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {modal?.confirmCancelMember && (
        <Modal
          show={modal.confirmCancelMember}
          onHide={() => toggleModalCancelMember()}
          className="modal--sm confirm__cancel"
          style={{ opacity: 1 }}
          centered
          dialogClassName={styles.modalDialogSm}
        >
          <Modal.Header closeButton>
            <h4 className={styles.modalHeaderTitle}>
              {t("navBar.myAccount.popUp.withDrawal.title")}
            </h4>
          </Modal.Header>
          <Modal.Body className={styles.modalBodySm}>
            <p className="text text--14">
              {t("navBar.myAccount.popUp.withDrawal.withDrawalInfo")}
            </p>
            <p className="text text--13 text--gray mg mt-10">
              {t("navBar.myAccount.popUp.withDrawal.withDrawalInfo_2")}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className={`${styles.primaryActionButton}`}
              onClick={confirmCancelMember}
            >
              {t("common.okBtn")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default MyAccountUI;
